import Views from '../../views/host/hostRegistration/HostRegistrationViews';
import getInitialStateOmeRoute from './GetInitialStateOmeRoute';
import getInitialStateMeetRoute from './GetInitialStateMeetRoute';
import { eligibilityIsComplete, meetInfoIsComplete, restrictionsIsComplete, sessionsIsComplete } from './LeftNavValidation';

const getSessions = (viewName, route, omeMeetStateObjData, meetStateObjData, omeMeetEntryStateObjData, restrictionsRoutePermission, eligibilityRoutePermission, meetInfoRoutePermission, HIDE_OME_ELIGIBILITY_50_BONUS_OPTION) => {
  const isCurrent = viewName === Views.OME_MEET_SESSIONS;

  const isMeetInfoComplete = meetInfoIsComplete(omeMeetStateObjData, meetStateObjData, omeMeetEntryStateObjData, meetInfoRoutePermission);
  const isEligibilityComplete = eligibilityIsComplete(omeMeetStateObjData, omeMeetEntryStateObjData, eligibilityRoutePermission, HIDE_OME_ELIGIBILITY_50_BONUS_OPTION);
  const isRestrictionsComplete = restrictionsIsComplete(omeMeetStateObjData, restrictionsRoutePermission);

  const isComplete = isMeetInfoComplete === true && isEligibilityComplete === true && isRestrictionsComplete === true 
    && sessionsIsComplete(meetStateObjData);

  const arePrerequisitesDone = isMeetInfoComplete === true && isEligibilityComplete === true
    && isRestrictionsComplete === true;

  const item = route === '' ? getInitialStateOmeRoute(Views.OME_MEET_SESSIONS) : getInitialStateMeetRoute(Views.OME_MEET_SESSIONS);

  return {
    ...item,
    isCurrent,
    isComplete,
    arePrerequisitesDone
  };
};

export default getSessions;